import SaveAltIcon from '@mui/icons-material/SaveAlt';
import CircularProgress from '@mui/material/CircularProgress';
import Snackbar from '@mui/material/Snackbar';
import Typography from '@mui/material/Typography';
import { ISchedules } from '../../../../services/journey.service';
import DownloadItemViewModel from './viewModel';
import { DownloadButton, FeedbackToast } from './styled';

interface Props {
  schedule: ISchedules;
}

export default function DownloadItem({ schedule }: Props) {
  const { loadingPDF, generatePDF, label, showFeedback, handleCloseFeedback } = DownloadItemViewModel({
    schedule
  });

  return (
    <>
      <DownloadButton color="primary" onClick={generatePDF} sx={{ cursor: 'pointer' }}>
        <SaveAltIcon /> {label}
        {loadingPDF && <CircularProgress size={20} sx={{ color: 'brand.darkGreen' }} />}
      </DownloadButton>
      <Snackbar
        open={showFeedback}
        autoHideDuration={4000}
        onClose={handleCloseFeedback}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <FeedbackToast>
          <Typography component="p">Verifique o arquivo nos seus downloads.</Typography>
        </FeedbackToast>
      </Snackbar>
    </>
  );
}
